"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Icon_1 = __importDefault(require("../Icon"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var ScrollDetector_1 = __importDefault(require("../Header/ScrollDetector"));
var Box_1 = __importDefault(require("../Box"));
var ResponsiveLogo_1 = __importDefault(require("../Header2/ResponsiveLogo"));
var ThemeColorMeta_1 = __importDefault(require("../Header/ThemeColorMeta"));
var Drawer_1 = __importDefault(require("./Drawer"));
var useDisableBodyScroll_1 = __importDefault(require("../hooks/useDisableBodyScroll"));
var constants_1 = require("./constants");
var Link_1 = __importDefault(require("../Link"));
var isActivePath_1 = require("../utils/isActivePath");
var Header2 = function (props) {
    var _a = props || {}, drawerLinks = _a.drawerLinks, centerLinks = _a.centerLinks, _b = _a.colorTheme, colorTheme = _b === void 0 ? 'LIGHT' : _b, transparent = _a.transparent, scrollEffect = _a.scrollEffect, zIndex = _a.zIndex, drawerZIndex = _a.drawerZIndex, float = _a.float, spacer = _a.spacer, background = _a.background, logoType = _a.logoType, logoLink = _a.logoLink;
    var _c = (0, react_1.useState)(false), menuOpen = _c[0], setMenuOpen = _c[1];
    var _d = (0, react_1.useState)(false), isMenuFocusable = _d[0], setIsMenuFocusable = _d[1];
    var _e = (0, react_1.useState)(false), isHidden = _e[0], setIsHidden = _e[1];
    var menuRef = (0, react_1.useRef)(null);
    (0, useDisableBodyScroll_1.default)(menuOpen);
    // After closing the menu with a key press, highlight the hamburger menu
    (0, react_1.useEffect)(function () {
        if (!menuRef.current)
            return;
        if (!menuOpen && isMenuFocusable) {
            menuRef.current.focus();
        }
    }, [menuOpen, isHidden, isMenuFocusable]);
    var handleScroll = function (scrollPosition, scrollDirection, isBottom) {
        if (scrollPosition <= 0 || // mobile safari will bounce below 0
            scrollDirection === 'DOWN' && scrollPosition < 400 ||
            scrollDirection === 'UP' && scrollPosition > 0 && !isBottom) { // mobile safari will bounce at bottom
            setIsHidden(false);
        }
        else {
            setIsHidden(true);
            setMenuOpen(false);
        }
    };
    var drawerProps = {
        colorTheme: colorTheme,
        navLinks: drawerLinks,
        open: menuOpen,
        onClose: function () { return setMenuOpen(false); },
        zIndex: drawerZIndex,
    };
    var needSpacer = spacer;
    if (!float) {
        // when header is not floated, no need for spacer holder
        needSpacer = false;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ThemeColorMeta_1.default, { colorTheme: colorTheme }),
        scrollEffect && react_1.default.createElement(ScrollDetector_1.default, { onScroll: handleScroll }),
        react_1.default.createElement(StyledHeader, { id: 'ff-ui-header', colorTheme: colorTheme, transparent: transparent, scrollEffect: scrollEffect, isHidden: isHidden, zIndex: zIndex, background: background, position: float ? 'fixed' : undefined },
            react_1.default.createElement(TopBar, null,
                react_1.default.createElement(MenuSection, null,
                    react_1.default.createElement(Box_1.default, { ref: menuRef, tabIndex: 0, "aria-haspopup": 'true', "aria-label": 'open menu', display: 'flex', onClick: function () { return setMenuOpen(true); }, onKeyPress: function (event) {
                            event.preventDefault();
                            if (event.key === 'Enter') {
                                setMenuOpen(true);
                                setIsMenuFocusable(true);
                            }
                        } },
                        react_1.default.createElement(MenuButton, null,
                            react_1.default.createElement(MenuIcon, { name: 'ff-icon-menu-2', "aria-label": 'open menu' })))),
                react_1.default.createElement(CenterNavigation, null, centerLinks === null || centerLinks === void 0 ? void 0 : centerLinks.map(function (link, index) { return (react_1.default.createElement(react_1.default.Fragment, { key: link.label },
                    react_1.default.createElement(CenterLink, { href: link.url, colorTheme: colorTheme, active: (0, isActivePath_1.isActivePath)(link.url) }, link.label),
                    centerLinks.filter(function (link) { return link.label.trim(); }).length >= 2 && index < centerLinks.length - 1 && (react_1.default.createElement(NavDivider, { colorTheme: colorTheme })))); })),
                react_1.default.createElement(ResponsiveLogo_1.default, { colorTheme: colorTheme, type: logoType, logoLink: logoLink }))),
        needSpacer && react_1.default.createElement(Spacer, { colorTheme: colorTheme }),
        menuOpen && react_1.default.createElement(Drawer_1.default, __assign({}, drawerProps))));
};
var StyledHeader = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme, colorTheme = _a.colorTheme, transparent = _a.transparent, background = _a.background, scrollEffect = _a.scrollEffect, isHidden = _a.isHidden, zIndex = _a.zIndex;
    return (_b = {
            top: (scrollEffect && isHidden) ? -constants_1.MOBILE_MENU_HEIGHT : 0,
            left: 0,
            color: colorTheme === 'DARK' ? theme.colors.contrastText : theme.colors.text,
            width: '100%',
            transition: 'top 0.5s ease',
            zIndex: zIndex === undefined ? theme.zIndices.menubar : zIndex,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            backdropFilter: transparent ? undefined : 'blur(10px)',
            background: background
                // if background color is provided use it,
                ? background
                : transparent
                    // if it's transparent, no background color
                    ? undefined
                    // if no background color from props and not transparent, use default colors for theme
                    : colorTheme === 'DARK'
                        ? 'rgba(0,0,0,0.75)'
                        : 'rgba(255,255,255,0.75)'
        },
        _b[theme.mediaQueries.md] = {
            top: (scrollEffect && isHidden) ? -constants_1.MENU_HEIGHT : 0,
        },
        _b);
});
StyledHeader.defaultProps = { as: 'header' };
var TopBar = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            height: constants_1.MOBILE_MENU_HEIGHT,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: 'row',
            paddingLeft: '10px',
            paddingRight: '10px',
            width: '100%'
        },
        // prevent layout shift when menu opens
        // maxWidth: 'calc(100vw - 20px)',
        _b[theme.mediaQueries.md] = {
            height: constants_1.MENU_HEIGHT,
            paddingLeft: '40px',
            paddingRight: '40px',
        },
        _b);
});
var MenuSection = (0, styled_1.default)(Box_1.default)({
    display: 'flex'
});
var Spacer = (0, styled_1.default)(Box_1.default)(function (props) {
    var _a;
    var theme = props.theme, colorTheme = props.colorTheme;
    return _a = {
            width: '100%',
            height: constants_1.MOBILE_MENU_HEIGHT,
            backgroundColor: colorTheme === 'DARK' ? theme.colors.black : theme.colors.white
        },
        _a[theme.mediaQueries.md] = {
            height: constants_1.MENU_HEIGHT,
        },
        _a;
});
var MenuButton = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'row-reverse',
            alignItems: 'center'
        },
        _b[theme.mediaQueries.md] = {
            flexDirection: 'row',
        },
        _b);
});
var MenuIcon = (0, styled_1.default)(Icon_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            fontSize: '30px'
        },
        _b[theme.mediaQueries.md] = {
            fontSize: '32px',
        },
        _b);
});
var LinkSection = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'none'
        },
        _b[theme.mediaQueries.md] = {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
        },
        _b);
});
LinkSection.defaultProps = { as: 'nav' };
var CenterNavigation = (0, styled_1.default)(Box_1.default)({
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    '@media screen and (min-width: 900px)': {
        gap: '16px',
    }
});
var CenterLink = (0, styled_1.default)(Link_1.default)(function (_a) {
    var theme = _a.theme, colorTheme = _a.colorTheme, active = _a.active;
    return ({
        color: colorTheme === 'DARK'
            ? active ? theme.colors.contrastText : 'rgba(255, 255, 255, 1)'
            : active ? theme.colors.text : 'rgba(0, 0, 0, 1)',
        textDecoration: 'none',
        fontSize: '14px',
        lineHeight: '16px',
        transition: 'all 0.2s ease',
        position: 'relative',
        whiteSpace: 'nowrap',
        '@media screen and (min-width: 900px)': {
            fontSize: '16px',
            lineHeight: '20px',
        },
        '&:hover': {
            opacity: 0.7
        },
        '&:after': {
            content: '""',
            position: 'absolute',
            bottom: '-1px',
            left: 0,
            width: '100%',
            height: '1px',
            background: colorTheme === 'DARK' ? theme.colors.contrastText : theme.colors.text,
            opacity: active ? 1 : 0.7,
            transition: 'opacity 0.2s ease'
        }
    });
});
var NavDivider = styled_1.default.span(function (_a) {
    var colorTheme = _a.colorTheme;
    return ({
        width: '1px',
        height: '12px',
        background: colorTheme === 'DARK' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)',
        '@media screen and (min-width: 900px)': {
            height: '16px',
        }
    });
});
Header2.defaultProps = defaultProps_1.default;
exports.default = Header2;
